import gql from 'graphql-tag'

export const fetchProductsQuery = gql`
  query (
    $sku: [String]
    $search: String
    $sort: ProductAttributeSortInput
    $brand: [String]
    $category_uid: [String]
    $pack_format: [String]
    $filter_packaging: [String]
    $dimension: [String]
    $currentPage: Int!
    $pageSize: Int = 25
    $product_last: String
    $product_new: String
    $product_sale: String
    $product_recommended: String
    $type_id: String
  ) {
    products(
      search: $search
      filter: {
        sku: { in: $sku }
        brand: { in: $brand }
        pack_format: {in : $pack_format}
        category_uid: { in: $category_uid }
        filter_packaging: { in: $filter_packaging }
        dimension: { in: $dimension }
        product_last: { eq: $product_last }
        product_new: { eq: $product_new }
        product_sale: { eq: $product_sale }
        product_recommended: { eq: $product_recommended }
        type_id: { eq: $type_id }
      }
      pageSize: $pageSize
      currentPage: $currentPage
      sort: $sort
    ) {
      total_count
      aggregations {
        attribute_code
        count
        label
        options {
          label
          value
          count
        }
      }
      items {
        multi_deposit
        material_type
        number_of_items_in_box
        name
        deliveryDate
        sku
        your_price
        your_price_tax
        ean_ea
        product_reco_tags {
          value
          label
          color
        }
        number_of_pieces_in_crate
        number_of_pieces_in_carton
        favourites
        promo
        product_last
        product_new
        product_sale
        product_recommended
        number_of_products_on_layer
        number_of_items_on_pallet
        number_of_layers_per_pallet
        isavailable_truck_package_ordering
        multi_deposit_z099
        pack_format
        redemption_fee
        volume
         #saleability {
          # next_date
          # sellable
         #}
        description {
          html
        }
        small_image {
          url
        }
        cart_fields {
          packaging_cart
          layer_cart
          pallets_cart
        }
        ... on BundleProduct {
          your_price_sum
          your_price_sum_tax
          bundle_price_sum
          bundle_price_sum_tax
          bundle_fields {
            minimum_amt
            valid_from
            valid_to
            limited_amount
          }
          items {
            title
            sku
            type
            required
            position
            your_price_sum
            your_price_sum_tax
            options {
              uid
              id
              label
              quantity
              price
              price_type
              position
              product {
                id
                name
                sku
                your_price
                your_price_tax
              }
            }
          }
        }
      }
      page_info {
        page_size
        total_pages
        current_page
      }
    }
  }
`
